import Meta from 'components/meta/meta'
import Panel from 'components/panel/panel'
import Heading from 'components/heading/heading'
import ResetPassword from 'components/reset-password/reset-password'

export default function Page(query) {
    return (
        <>
            <Meta
                title="Slaptažodžio atkūrimas"
                description="Šiame puslapyje galite atkurti pamirštą paskyros slaptažodį."
            />
            <Panel desktop size="small">
                <Heading tag="h1" size="30">
                    Slaptažodžio atkūrimas
                </Heading>
                <ResetPassword code={query.reset} withLoginLink />
            </Panel>
        </>
    )
}

export async function getServerSideProps(context) {
    return {
        props: context.query
    }
}
